
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3677F6","d":"M66.67 10H13.33A3.34 3.34 0 0010 13.33V35.4c0 1.83 1.5 3.33 3.33 3.33h53.34c1.83 0 3.33-1.5 3.33-3.33V13.33A3.31 3.31 0 0066.67 10z"}}),_c('path',{attrs:{"fill":"#BFD8FB","d":"M25.83 43.66h-12.5A3.34 3.34 0 0010 46.98v19.7C10 68.5 11.5 70 13.33 70h12.5c1.83 0 3.33-1.5 3.33-3.33V46.98c0-1.82-1.5-3.32-3.33-3.32z"}}),_c('path',{attrs:{"fill":"#70A0FF","d":"M66.67 43.66H38.24a3.34 3.34 0 00-3.33 3.32v19.7c0 1.82 1.5 3.32 3.33 3.32h28.43C68.5 70 70 68.5 70 66.67V46.98a3.31 3.31 0 00-3.33-3.32z"}})])
          )
        }
      }
    